import React, { useEffect } from "react";
import useClockStart from "../../modules/user/hooks/use-clock-start";

export default function ClockSetter() {

    const startTime = useClockStart();

    useEffect(() => {
        startTime();
    }, [startTime])

    return (<></>);
}
